import { Box, Collapse, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ReactComponent as ChevronDownIcon } from 'src/assets/svg/chevron-down.svg';
import { selectRoom } from 'src/store/slices/booking-slice';

import { RoomCard } from './room-card';
import { styles } from './styles';

export const RoomCardMobileOverview: FC = () => {
    const [showRoomInfo, setShowRoomInfo] = useState<boolean>(false);
    const roomData = useSelector(selectRoom);
    const { t } = useTranslation();

    const toggleRoomInfo = () => setShowRoomInfo((prev) => !prev);

    return (
        <Box css={styles.mobileRoom}>
            <Box onClick={toggleRoomInfo} css={styles.mobileRoomTitle}>
                <Typography variant="h4" css={styles.roomTitle}>
                    {t('room_card_mobile_name')} {roomData?.room_code}
                </Typography>
                <ChevronDownIcon css={showRoomInfo && styles.roomCardExpanded} />
            </Box>
            <Collapse in={showRoomInfo}>
                <Box css={styles.roomCardWrapper}>
                    <RoomCard roomData={roomData} />
                </Box>
            </Collapse>
        </Box>
    );
};
